import { schema } from 'normalizr'

export const stateSchema = new schema.Entity(
  'states',
  {},
  { idAttribute: 'code' }
)
